import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function HotArticlesSection() {
  const featuredArticles = articles.filter((a) => a.isFeatured);
  const hotArticles = articles.filter((a) => a.isHot && !a.isFeatured);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 text-xs bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
              热门内容
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
          </div>
          <a
            href="/category/films-tv"
            className="hidden sm:flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          {featuredArticles.slice(0, 2).map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
          <div className="bg-background-50 rounded-lg border border-background-200/60 p-4">
            <h3 className="text-sm font-semibold text-foreground-700 mb-4 px-1">热门阅读</h3>
            <div className="flex flex-col">
              {hotArticles.slice(0, 4).map((article, index) => (
                <div key={article.slug}>
                  <ArticleCard article={article} variant="compact" />
                  {index < hotArticles.slice(0, 4).length - 1 && (
                    <div className="border-b border-background-200/40 mx-3"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles
            .filter((a) => !a.isFeatured)
            .slice(0, 4)
            .map((article) => (
              <ArticleCard key={article.slug} article={article} />
            ))}
        </div>
      </div>
    </section>
  );
}